/* eslint-disable max-len */
/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for RedirectLinkIcon
 *
 * @author Ujjwal Sana
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const RedirectLinkIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 16 16"
    fontSize="inherit"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M4.8963 2.77332C5.32585 2.77332 5.67407 3.12154 5.67407 3.5511C5.67407 3.98065 5.32585 4.32888 4.8963 4.32888H1.66667C1.6053 4.32888 1.55556 4.37862 1.55556 4.43999V12.5467C1.55556 12.608 1.6053 12.6578 1.66667 12.6578H9.77333C9.8347 12.6578 9.88444 12.608 9.88444 12.5467V9.31702C9.88444 8.88747 10.2327 8.53925 10.6622 8.53925C11.0918 8.53925 11.44 8.88747 11.44 9.31702V12.5467C11.44 13.4671 10.6938 14.2133 9.77333 14.2133H1.66667C0.746192 14.2133 0 13.4671 0 12.5467V4.43999C0 3.51951 0.746192 2.77332 1.66667 2.77332H4.8963ZM13.2133 0C13.7288 0 14.1532 0.39001 14.2074 0.891039L14.2133 1V6.32444C14.2133 6.754 13.8651 7.10222 13.4355 7.10222C13.039 7.10222 12.7118 6.80551 12.6638 6.42201L12.6578 6.32444L12.6571 2.65511L6.29419 9.01907C6.01576 9.2975 5.57876 9.3207 5.2739 9.08868L5.19425 9.01907C4.91582 8.74064 4.89262 8.30363 5.12464 7.99877L5.19425 7.91912L11.5576 1.55556H7.88887C7.49236 1.55556 7.16515 1.25884 7.11716 0.875341L7.1111 0.777778C7.1111 0.381266 7.40781 0.054054 7.79131 0.00605999L7.88887 0H13.2133Z" fill="currentColor" />
  </SvgIcon>
);

export default RedirectLinkIcon;
